import { render, staticRenderFns } from "./country-dropdown.vue?vue&type=template&id=28b848cf"
import script from "./country-dropdown.vue?vue&type=script&lang=js"
export * from "./country-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports